require('./bootstrap');

import Timing from "./Timing";

new Timing();
